import moment from 'moment';
import 'moment-timezone';

class EmptySlot {
  slotType = 'empty';

  constructor(time) {
    this.time = time;
    this.midnight = moment(time).startOf('day').toISOString();
  }

  isEmpty() {
    return true;
  }
}

export { EmptySlot };
